import React, { useState } from 'react'
import Popover from 'react-popover'
import PropTypes from 'prop-types'

const UniversalPopover = ({ body, place, preferPlace, children, windowSizeWidth, showModal }) => {
  const [isOpen, setIsOpen] = useState(false)
  if (windowSizeWidth < 490) {
    return <span onClick={() => showModal(body, { size: 'xxs' })}>{children}</span>
  }
  return (
    <Popover
      isOpen={isOpen}
      preferPlace={preferPlace}
      place={place}
      onOuterAction={() => setIsOpen(!isOpen)}
      body={body}
      tipSize={7}
    >
      <span onClick={() => setIsOpen(!isOpen)}>{children}</span>
    </Popover>
  )
}

UniversalPopover.defaultProps = {
  place: null,
  preferPlace: 'below',
}

UniversalPopover.propTypes = {
  preferPlace: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default UniversalPopover
